import { render, staticRenderFns } from "./tobeSentCommission.vue?vue&type=template&id=058b1df0&"
import script from "./tobeSentCommission.vue?vue&type=script&lang=js&"
export * from "./tobeSentCommission.vue?vue&type=script&lang=js&"
import style0 from "./tobeSentCommission.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports